const selectors = {
  block: "[data-target-group]",
  button: "[data-target-group-button]",
};

const initBlock = (block) => {
  const buttons = block.querySelectorAll(selectors.button);

  // buttons.forEach((button) =>
  //   button.addEventListener("click", () => (document.cookie = `target-group=${button.dataset.targetGroupButton}`))
  // );

  buttons.forEach((button) =>
    button.addEventListener("click", () => {
      setCookie('user_type_preference', button.dataset.targetGroupButton, 365);
    })
  );
};

function setCookie(name, value, days) {
  const expires = new Date();
  expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
  
  const domain = window.location.hostname.replace(/^www\./, '');
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/;domain=.${domain};SameSite=Lax`;
}

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    const blocks = document.querySelectorAll(selectors.block);

    blocks?.forEach(initBlock);
  },
  {
    once: true,
  }
);